/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiFinalRiskLevel } from './InternalApiFinalRiskLevel';
import {
    InternalApiFinalRiskLevelFromJSON,
    InternalApiFinalRiskLevelFromJSONTyped,
    InternalApiFinalRiskLevelToJSON,
    InternalApiFinalRiskLevelToJSONTyped,
} from './InternalApiFinalRiskLevel';

/**
 * Bulk risk override command
 * @export
 * @interface InternalApiBulkRiskOverrideCommand
 */
export interface InternalApiBulkRiskOverrideCommand {
    /**
     * List of person external IDs
     * @type {Array<string>}
     * @memberof InternalApiBulkRiskOverrideCommand
     */
    personExternalIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBulkRiskOverrideCommand
     */
    reasonHandle: string;
    /**
     * 
     * @type {InternalApiFinalRiskLevel}
     * @memberof InternalApiBulkRiskOverrideCommand
     */
    level: InternalApiFinalRiskLevel;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBulkRiskOverrideCommand
     */
    comment: string;
}



/**
 * Check if a given object implements the InternalApiBulkRiskOverrideCommand interface.
 */
export function instanceOfInternalApiBulkRiskOverrideCommand(value: object): value is InternalApiBulkRiskOverrideCommand {
    if (!('personExternalIds' in value) || value['personExternalIds'] === undefined) return false;
    if (!('reasonHandle' in value) || value['reasonHandle'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function InternalApiBulkRiskOverrideCommandFromJSON(json: any): InternalApiBulkRiskOverrideCommand {
    return InternalApiBulkRiskOverrideCommandFromJSONTyped(json, false);
}

export function InternalApiBulkRiskOverrideCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiBulkRiskOverrideCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'personExternalIds': json['personExternalIds'],
        'reasonHandle': json['reasonHandle'],
        'level': InternalApiFinalRiskLevelFromJSON(json['level']),
        'comment': json['comment'],
    };
}

export function InternalApiBulkRiskOverrideCommandToJSON(json: any): InternalApiBulkRiskOverrideCommand {
    return InternalApiBulkRiskOverrideCommandToJSONTyped(json, false);
}

export function InternalApiBulkRiskOverrideCommandToJSONTyped(value?: InternalApiBulkRiskOverrideCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personExternalIds': value['personExternalIds'],
        'reasonHandle': value['reasonHandle'],
        'level': InternalApiFinalRiskLevelToJSON(value['level']),
        'comment': value['comment'],
    };
}

